module.exports = __webpack_public_path__ + "img/star0.420d8ce9.svg";